<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="8" fill="#fff" />
    <path
      d="M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM11.5303 4.46973C11.2374 4.17683 10.7626 4.17683 10.4697 4.46973L8 6.93945L5.53027 4.46973C5.23738 4.17683 4.76262 4.17683 4.46973 4.46973C4.17683 4.76262 4.17683 5.23738 4.46973 5.53027L6.93945 8L4.46973 10.4697C4.17683 10.7626 4.17683 11.2374 4.46973 11.5303C4.76262 11.8232 5.23738 11.8232 5.53027 11.5303L8 9.06055L10.4697 11.5303L10.5264 11.582C10.8209 11.8223 11.2557 11.8049 11.5303 11.5303C11.8049 11.2557 11.8223 10.8209 11.582 10.5264L11.5303 10.4697L9.06055 8L11.5303 5.53027C11.8232 5.23738 11.8232 4.76262 11.5303 4.46973Z"
      fill="#868D9C"
    />
  </svg>
</template>
